module.exports = __webpack_public_path__ + "media/images/cover/livingroom-f456eb024e8509aaec912bd54045b2b1.jpg";